import React, { useEffect, useState } from 'react'
import RoomPreviewHeader from '../components/data-room-preview/RoomPreviewHeader'
import RoomPreviewFooter from '../components/data-room-preview/RoomPreviewFooter'
import folderIconXLarge from '../../../../_metronic/assets/images/svg/data-room/blue-folder-X-large-icon.svg'
import blueFolderIcon from '../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import { useIntl } from 'react-intl'
import { EmailAccessModal } from '../components/data-room-drawer/EmailAccessModal'
import { useLocation } from 'react-router-dom'
import {
  downloadFileSignedForContent,
  getFileByShareLink,
  openFolderDrShareLink,
} from '../core/_requests'
import { toast } from 'react-toastify'
import { PasscodeAccessModal } from '../components/data-room-drawer/PasscodeAccessModal'
import { ContentTypes } from '../core/_constants'
import { useNavigate } from 'react-router-dom'
import { DateTime } from 'luxon'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { GET_FILE_URL } from '../../onboarding/core/_requests'
import NoDataPage from '../../widgets/components/NoDataPage'
import { Spinner } from '../../widgets/components/General/Spinner'
import { OtpAccessModal } from '../components/data-room-drawer/OtpAccessModal'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'

function DataRoomPreview() {
  const { formatMessage } = useIntl()
  const location = useLocation()
  const [dataRoomPublicRes, setDataRoomPublicRes] = useState<any>([])
  const [folderclickLoading, setFolderClickLoading] = useState<boolean>(false)
  const [breadcrumbs, setBreadcrumbs] = useState<any>([])
  const [visibleData, setVisibleData] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [otp, setOtp] = useState<string>('')
  const [emailIdErr, setEmailIdErr] = useState<boolean>(false)
  const [passwordErr, setPasswordErr] = useState<boolean>(false)
  const [otpErr, setOtpErr] = useState<boolean>(false)
  const [showPasscodeModal, setShowPasscodeModal] = useState<boolean>(false)
  const [showOtpModal, setShowOtpModal] = useState<boolean>(false)
  const [showEmailModal, setShowEmailModal] = useState<boolean>(false)
  const [isEnteringEmail, setIsEnteringEmail] = useState<boolean>(false)
  const [isEnteringOtp, setIsEnteringOtp] = useState<boolean>(false)
  const [isEnteringPasscode, setIsEnteringPasscode] = useState<boolean>(false)
  const [updatedDate, setUpdatedDate] = useState<string>('')
  const [bgImage, setBgImage] = useState<string>('')
  const [drTitle, setDrTitle] = useState<string>('')
  const [drSubTitle, setDrSubTitle] = useState<string>('')
  const [userFirstName, setUserFirstName] = useState<string>('')
  const [userLastName, setUserLastName] = useState<string>('')
  const [userEmail, setUserEmail] = useState<string>('')
  const [userIcon, setUserIcon] = useState<string>('')
  const [drIconImage, setDrIconImage] = useState<string>('')
  const [companyName, setCompanyName] = useState<string>('')
  const [companyUrl, setCompanyUrl] = useState<string>('')
  const [companyIcon, setCompanyIcon] = useState<string>('')
  const [isDownloadable, setIsDownloadable] = useState<boolean>(false)
  const pathname = location.pathname
  const parts = pathname.split('/')
  const paramValue = parts[parts.length - 1]
  const navigate = useNavigate()
  const { currentUser, companyId } = useAuth()

  const getAllPublicShareLink = async (
    uuid: string,
    passcode: string | undefined,
    email: string | undefined,
    otp: string | undefined
  ) => {
    try {
      if (email) setIsEnteringEmail(true)
      if (passcode && email) setIsEnteringPasscode(true)
      if (otp) setIsEnteringOtp(true)
      const {
        data: { data, success: successData, errors: errorsData },
      } = await getFileByShareLink(uuid, passcode, email, otp)
      if (successData) {
        if (data === 'OTP_SENT') {
          setShowOtpModal(true)
          setShowEmailModal(false)
        } else {
          if (data.otp_verified === 'OTP_VERIFIED' && data.passcode) {
            setShowOtpModal(false)
            setIsEnteringPasscode(false)
            setShowPasscodeModal(true)
          } else {
            setShowOtpModal(false)
            setShowEmailModal(false)
            setIsEnteringOtp(false)
            setDataRoomPublicRes(data?.dataRoomContents?.contents)
            localStorage.setItem('DataRoomSession', data?.publicSession?.sessionToken)
            setBgImage(data?.dataRoomContents?.dataRoomBanner?.name)
            setDrIconImage(data?.dataRoomContents?.dataRoomLogo?.name)
            setDrTitle(data.dataRoomContents?.title)
            setUserFirstName(data?.dataRoomContents?.user?.firstName)
            setUserLastName(data?.dataRoomContents?.user?.lastName)
            setUserEmail(data?.dataRoomContents?.user?.email)
            setDrSubTitle(data?.dataRoomContents?.subtitle)
            setUserIcon(data?.dataRoomContents?.user?.file?.name)
            setCompanyName(data?.dataRoomContents?.company?.name)
            setCompanyUrl(data?.dataRoomContents?.company?.website)
            setCompanyIcon(data?.dataRoomContents?.company?.file?.name)
            setIsDownloadable(data?.allowDownload)
            setUpdatedDate(data?.dataRoomContents?.updatedAt)
            setVisibleData(true)
            if (showEmailModal) {
              setShowEmailModal(false)
              setIsEnteringEmail(false)
            }
            if (showPasscodeModal) {
              setShowPasscodeModal(false)
              setIsEnteringPasscode(false)
            }
            if (showOtpModal) {
              setShowOtpModal(false)
              setIsEnteringOtp(false)
            }
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.DataRoomPreviewSuccessful,
                action: 'normal',
                metadata: {
                  first_name: data?.dataRoomContents?.user?.firstName,
                  user_last_name: data?.dataRoomContents?.user?.lastName,
                  user_email: data?.dataRoomContents?.user?.email,
                  company_name: data?.dataRoomContents?.company?.name,
                  company_url: data?.dataRoomContents?.company?.website,
                  is_downloadable: data?.allowDownload,
                  updated_date: data?.dataRoomContents?.updatedAt,
                  company_id: companyId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                },
              },
            })
          }
        }
      } else {
        errorsData.forEach((error: string) => {
          if (error === 'EMAIL_REQUIRED') {
            setShowEmailModal(true)
            setShowOtpModal(false)
          } else if (error === 'INVALID_OTP') {
            toast.error(formatMessage({ id: 'Otp is Invalid, Please try again' }))
            setIsEnteringOtp(false)
            setShowOtpModal(true)
            setShowEmailModal(false)
          } else if (error === 'PASSCODE_REQUIRED') {
            setShowEmailModal(false)
            setShowPasscodeModal(true)
            setShowOtpModal(false)
          } else if (error === 'ACL_FAILED') {
            toast.error(formatMessage({ id: 'You are not allowed to access the dataroom' }))
            setIsEnteringEmail(false)
            setShowOtpModal(false)
          } else {
            toast.error(formatMessage({ id: error }))
            setIsEnteringEmail(false)
            setIsEnteringPasscode(false)
            setShowOtpModal(false)
            setIsEnteringOtp(false)
          }
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleFolderClick = async (parentId: string | null) => {
    setFolderClickLoading(true)
    try {
      const {
        data: { data, success: successData, errors: errorsData },
      } = await openFolderDrShareLink(parentId, localStorage.getItem('DataRoomSession'))

      if (successData) {
        setDataRoomPublicRes(data?.childrenContent?.contents)
        setBreadcrumbs(data?.breadcrumb)
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.OpenFolderDataroomShareLinkSuccessful,
            action: 'normal',
            metadata: {
              parent_id: parentId,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        errorsData.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setFolderClickLoading(false)
    }
  }

  const handleFileClicked = (id: number) => {
    const newTab = window.open(`/file/view/${id}`, '_blank')
    if (newTab) {
      newTab.focus()
    } else {
      navigate(`/file/view/${id}`)
    }
  }

  function getTimeDifference(date: any) {
    const minutes = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject()
          .minutes
      )
    )

    const days = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().days
      )
    )

    const hours = Math.abs(
      Math.floor(
        date &&
        DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().hours
      )
    )
    if (days === 0 && hours === 0) {
      return `${minutes} ${formatMessage({ id: 'min ago' })}`
    }
    if (days === 0) {
      return `${hours} ${formatMessage({ id: 'hrs ago' })}`
    } else if (days === 7) {
      return `${formatMessage({ id: '1 week' })}`
    } else if (days < 7) {
      return `${days} ${formatMessage({ id: 'days ago' })}`
    } else {
      return DateTime.fromISO(date).toFormat('MMM dd')
    }
  }

  useEffect(() => {
    getAllPublicShareLink(paramValue, undefined, undefined, undefined)
  }, []) // eslint-disable-line

  const onDownloadFile = async (contentId: string) => {
    const {
      data: { data: signedUrl, success },
    } = await downloadFileSignedForContent(contentId, localStorage.getItem('DataRoomSession')!)
    if (success) {
      const a = document.createElement('a')
      a.href = signedUrl
      a.download = 'download'
      document.body.appendChild(a)
      a.click()
      a.remove() // This line is sufficient to remove the element from the DOM
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.DownloadSignedFileForContentSuccessful,
          action: 'normal',
          metadata: {
            content_id: contentId,
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
          },
        },
      })
    }
  }
  return (
    <div className={'room-preview-wrapper'}>
      {visibleData && (
        <>
          <RoomPreviewHeader
            companyName={companyName}
            userFirstName={userFirstName}
            userLastName={userLastName}
            userEmail={userEmail}
            userIcon={userIcon}
            companyUrl={companyUrl}
            companyIcon={companyIcon}
          />

          <div className='room-preview-body-wrapper'>
            <div
              className='room-preview-body-top'
              style={{
                backgroundImage: `url("${GET_FILE_URL}/${encodeURIComponent(bgImage || '')}")`,
              }}
            >
              <div className='overlay'></div>
              <div className='room-preview-body-top-content d-md-flex flex-row align-items-start'>
                <div className='room-space-profile-img-wrapper bg-white d-flex flex-row align-items-center justify-content-center'>
                  <DisplayImage imgName={drIconImage} width='100%' alt='profile' fit='contain' />
                </div>
                <div className=''>
                  <h3>
                    {formatMessage({ id: `Welcome to my ` })}
                    {drTitle}
                  </h3>
                  <span>{drSubTitle}</span>
                </div>
              </div>
            </div>
            <div className='room-preview-body-bottom bg-white '>
              <div className='room-preview-body-toolbar d-flex flex-row align-items-end justify-content-between dark-border'>
                <div className='body-toolbar-left'>
                  <span>
                    {formatMessage({ id: 'Last updated' })}
                    <span className='ms-2'>{getTimeDifference(updatedDate)}</span>
                  </span>
                </div>
              </div>
              <div className='mt-3'>
                {drTitle && (
                  <span
                    className='data-room-breadcrumb-title font-size-16'
                    onClick={() => handleFolderClick(null)}
                  >
                    {drTitle}{' '}
                  </span>
                )}
                {breadcrumbs?.reverse()?.map((item: any) => (
                  <React.Fragment key={item?.name}>
                    <span className='slash font-size-16'> / </span>
                    <span
                      className='breadcrumb-item data-room-breadcrumb-title'
                      onClick={() => handleFolderClick(item?.id)}
                    >
                      <img
                        src={blueFolderIcon}
                        alt={formatMessage({ id: 'Blue Folder Icon' })}
                        className='icon'
                      />{' '}
                      <span className='font-size-16'>{item?.name}</span>
                    </span>
                  </React.Fragment>
                ))}
              </div>

              {folderclickLoading ? <Spinner /> : null}
              {dataRoomPublicRes && !!dataRoomPublicRes.length ? (
                <div className='room-preview-grid'>
                  {dataRoomPublicRes?.map((item: any, id: number) => {
                    return (
                      <div className='deck-card-wrapper' key={id}>
                        <div
                          className='deck-card-img deck-folder-img d-flex flex-row align-items-center justify-content-center cursor-pointer'
                          onClick={() => {
                            if (item.type === ContentTypes.FOLDER) {
                              handleFolderClick(item?.dataroom_content?.dataroom_contentId)
                            } else {
                              handleFileClicked(item?.contentId)
                            }
                          }}
                        >
                          {item && item?.type === ContentTypes.FOLDER && (
                            <img
                              src={folderIconXLarge}
                              alt={formatMessage({ id: 'folder img' })}
                            ></img>
                          )}
                          {item &&
                            item?.type === ContentTypes.FILE &&
                            item?.file?.name.split('.').pop() === 'pdf' && (
                              <img
                                height={35}
                                width={35}
                                alt={formatMessage({ id: 'pdf' })}
                                className='pe-2'
                                src={toAbsoluteUrl(`/media/icons/file_extensions/${item?.file?.name.split('.').pop()}.svg`)}
                              />
                            )}
                          {item &&
                            item?.type === ContentTypes.FILE &&
                            (item?.file?.name.split('.').pop() === 'docx' ||
                              item?.file?.name.split('.').pop() === 'doc') && (
                              <img
                                height={35}
                                width={37}
                                alt={formatMessage({ id: 'docx' })}
                                className='pe-2'
                                src={toAbsoluteUrl(`/media/icons/file_extensions/${item?.file?.name.split('.').pop()}.svg`)}
                              />
                            )}
                          {item &&
                            item?.type === ContentTypes.FILE &&
                            (item?.file?.name.split('.').pop() === 'pptx' ||
                              item?.file?.name.split('.').pop() === 'ppt') && (
                              <img
                                height={35}
                                width={37}
                                alt={formatMessage({ id: 'pptx' })}
                                className='pe-2'
                                src={toAbsoluteUrl(`/media/icons/file_extensions/${item?.file?.name.split('.').pop()}.svg`)}
                              />
                            )}
                          {item &&
                            item?.type === ContentTypes.FILE &&
                            (item?.file?.name.split('.').pop() === 'jpg' ||
                              item?.file?.name.split('.').pop() === 'png' ||
                              item?.file?.name.split('.').pop() === 'jpeg') && (
                              <img
                                height={28}
                                width={28}
                                alt={formatMessage({ id: 'blank' })}
                                className='ms-n3'
                                src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                              />
                            )}
                          {item &&
                            item?.type === ContentTypes.FILE &&
                            item?.file?.name.split('.').pop() === 'xlsx' && (
                              <img
                                height={28}
                                width={28}
                                alt={formatMessage({ id: 'blank' })}
                                className='pe-2'
                                src={toAbsoluteUrl(`/media/icons/file_extensions/${item?.file?.name.split('.').pop()}.svg`)}
                              />
                            )}
                          {item &&
                            item?.type === ContentTypes.FILE &&
                            !(
                              item?.file?.name.split('.').pop() === 'pdf' ||
                              item?.file?.name.split('.').pop() === 'docx' ||
                              item?.file?.name.split('.').pop() === 'doc' ||
                              item?.file?.name.split('.').pop() === 'pptx' ||
                              item?.file?.name.split('.').pop() === 'ppt' ||
                              item?.file?.name.split('.').pop() === 'jpg' ||
                              item?.file?.name.split('.').pop() === 'png' ||
                              item?.file?.name.split('.').pop() === 'jpeg' ||
                              item?.file?.name.split('.').pop() === 'xlsx'
                            ) && (
                              <img
                                height={28}
                                width={28}
                                alt={formatMessage({ id: 'blank' })}
                                className='ms-n3'
                                src={toAbsoluteUrl('/media/svg/files/blank-image-single.svg')}
                              />
                            )}
                        </div>
                        <div className='deck-card-bottom'>
                          <span className='dark_text_color'>{item?.file?.fileName}</span>
                          {item.type === ContentTypes.FILE && (
                            <span
                              className={`cursor-pointer ${!isDownloadable && 'disableDiv'}`}
                              onClick={() => onDownloadFile(item?.contentId)}
                            >
                              <img
                                src={toAbsoluteUrl('/media/svg/files/download.svg')}
                                height={30}
                                width={30}
                                alt={formatMessage({ id: 'download-icon' })}
                              />
                            </span>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              ) : (
                <NoDataPage width={'w-0'} />
              )}
            </div>
          </div>
          <RoomPreviewFooter />
        </>
      )}

      <EmailAccessModal
        setAccessModal={setShowEmailModal}
        accessModal={showEmailModal}
        onAccess={getAllPublicShareLink}
        accessLoading={isEnteringEmail}
        AccessId={paramValue}
        email={email}
        setEmail={setEmail}
        heading={formatMessage({ id: 'Enter your email id to access this Data room' })}
        labelText={formatMessage({ id: 'Email Address' })}
        paraText={formatMessage({
          id: 'This Data Room has been shared with specific email ids, please enter your email id to access this data room.',
        })}
        emailIdErr={emailIdErr}
        setEmailIdErr={setEmailIdErr}
      />
      <PasscodeAccessModal
        setAccessModal={setShowPasscodeModal}
        accessModal={showPasscodeModal}
        onAccess={getAllPublicShareLink}
        accessLoading={isEnteringPasscode}
        AccessId={paramValue}
        passcode={password}
        setPasscode={setPassword}
        email={email}
        heading={formatMessage({ id: 'Enter password to access Data room' })}
        labelText={formatMessage({ id: 'Enter Passcode' })}
        passwordErr={passwordErr}
        setPasswordErr={setPasswordErr}
      />
      <OtpAccessModal
        setAccessModal={setShowOtpModal}
        accessModal={showOtpModal}
        onAccess={getAllPublicShareLink}
        accessLoading={isEnteringOtp}
        AccessId={paramValue}
        otp={otp}
        setOtp={setOtp}
        email={email}
        heading={formatMessage({ id: 'Enter otp to access Data room' })}
        labelText={formatMessage({ id: 'Enter otp' })}
        paraText={formatMessage({
          id: 'Otp has been sent to your email address, Please check the mail',
        })}
        otpErr={otpErr}
        setOtpErr={setOtpErr}
      />
    </div>
  )
}

export default DataRoomPreview
